import React from "react";

import Form from "2g-form";
import PageHeading from "2g-page-heading";
import KonfiguracniParamteryEditaceItem from "b2b/components/konfiguracni-parametry-editace-widget/KonfiguracniParamteryEditaceItem";

const PARAMS = require("b2b-devel/konfigparametry.json");

export function KonfiguracniParametryEditaceExample() {
  return (
    <>
      <PageHeading>KonfiguracniParamteryEditaceItem</PageHeading>
      <Form moduleKey="kofigParamsExample">
        <KonfiguracniParamteryEditaceItem konfiguracniParametr={PARAMS[0]} />
      </Form>
    </>
  );
}

export default React.memo(KonfiguracniParametryEditaceExample);
